export const DATA_QA_FIXED_OUTER_CONTAINER = 'fixed-outer-container';
